import axiosInstance from "./axiosInstance";

export interface IntercityCheckoutApi {
  interCityCheckoutId: number;
  publicId: string;
  tourType: number;
  fromVenueId: number;
  fromVenueName: string;
  toVenueId: number | null;
  toVenueName: string | null;
  checkoutTime: string;
  travelTime: string | null;
  startDate: string | null;
  endDate: string | null;
  miqaatId: number | null;
  miqaatName: string | null;
  isActive: boolean;
}

export interface IntercityCheckoutListResponse {
  items: IntercityCheckoutApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
  pageNumber: number;
}

export interface VenueApi {
  venueId: number;
  venueName: string;
  contactNo: string;
  emailAddress: string;
  description: string;
  timeZone: string;
  isActive: boolean;
}

export interface CreateIntercityCheckoutPayload {
    tourType: number;
    fromVenueId: number;
    toVenueId: number | null;
    checkoutTime: string;
    travelTime: string | null;
    startDate: string | null;
    endDate: string | null;
    miqaatId: number | null;
    isActive: boolean;
    createdBy: number;
}

export interface CreateIntercityCheckoutResponse {
  interCityCheckoutId: number;
}

export interface UpdateIntercityCheckoutPayload {
  tourType: number;
  fromVenueId: number;
  toVenueId: number | null;
  checkoutTime: string;
  travelTime: string | null;
  startDate: string | null;
  endDate: string | null;
  miqaatId: number | null;
  isActive: boolean;
  updatedBy: number;
}

export interface MiqaatApi {
  publicId: string;
  miqaatId: number;
  miqaatCode: string;
  miqaatName: string;
  description: string | null;
  cutoffDays: number;
  totalPaxLimit: number;
  requireRaza: boolean;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
  updatedBy: number;
  updatedOn: string;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getIntercityCheckouts = async (params: {
  pageNo: number;
  pageSize: number;
}): Promise<IntercityCheckoutListResponse> => {
  const res = await axiosInstance.get("/InterCityCheckouts/list", {
    headers: getAuthHeader(),
    params,
  });

  return res.data;
};

export const getVenues = async (): Promise<VenueApi[]> => {
  const res = await axiosInstance.get("/Venues?onlyActive=true", {
    headers: getAuthHeader(),
  });

  return res.data; 
};

export const createIntercityCheckout = async ( payload: CreateIntercityCheckoutPayload
  ): Promise<CreateIntercityCheckoutResponse> => {
  const res = await axiosInstance.post(
    "/InterCityCheckouts",
    payload,
    { headers: getAuthHeader() }
  );

  return res.data;
};

export const updateIntercityCheckout = async (publicId: string,
  payload: UpdateIntercityCheckoutPayload
  ): Promise<void> => {
  await axiosInstance.put(
    `/InterCityCheckouts/${publicId}`,
    payload,
    { headers: getAuthHeader() }
  );
};

export const deleteIntercityCheckout = async (
  publicId: string
): Promise<void> => {
  await axiosInstance.delete(
    `/InterCityCheckouts/${publicId}`,
    { headers: getAuthHeader() }
  );
};

export const getMiqaats = async (): Promise<MiqaatApi[]> => {
  const res = await axiosInstance.get("/miqaat", {
    headers: getAuthHeader(),
  });

  return res.data;
};